"use client";

import Image from "next/image";
import { SectionLayout } from "@/components/layout/SectionLayout";
import { getCloudinaryUrl } from "@/lib/cloudinary";

interface HeadSpaQuEstCeQueSectionProps {
  label: string;
  title: string;
  description: string;
  benefits: string[];
}

export const HeadSpaQuEstCeQueSection = ({
  label,
  title,
  description,
  benefits,
}: HeadSpaQuEstCeQueSectionProps) => {
  return (
    <SectionLayout id="quest-ce-que">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-start gap-12 md:grid-cols-[1fr_1.2fr] md:gap-16 lg:gap-20">
        {/* Contenu à gauche */}
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-4">
            <span className="text-sm uppercase tracking-[0.2em] text-gold">
              {label}
            </span>
            <h2 className="font-cormorant text-4xl font-light text-primary ph:text-5xl sm:text-6xl lg:text-7xl">
              {title}
            </h2>
          </div>

          <p className="max-w-xl text-lg leading-relaxed text-gray-700">
            {description}
          </p>

          <div className="flex flex-col gap-3">
            <div className="h-px w-12 bg-gold" />
            <ul className="flex flex-col gap-2">
              {benefits.map((benefit, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <svg
                    className="mt-1 h-4 w-4 shrink-0 text-gold"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-gray-700">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Image(s) à droite - grille asymétrique */}
        <div className="relative grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
          <div className="relative aspect-[4/5] w-full overflow-hidden sm:aspect-[3/4]">
            <Image
              src={getCloudinaryUrl("qu-est-ce-que-le-head-spa-1")}
              alt="Expérience Head Spa - massage crânien et relaxation"
              fill
              sizes="(max-width: 640px) 100vw, 50vw"
              className="object-cover"
            />
            <div className="absolute left-0 top-0 h-1 w-24 bg-gold" />
          </div>
          <div className="relative aspect-[4/5] w-full overflow-hidden sm:aspect-[3/4] sm:mt-12">
            <Image
              src={getCloudinaryUrl("qu-est-ce-que-le-head-spa-2")}
              alt="Head Spa L'Instant Grey - soin bien-être"
              fill
              sizes="(max-width: 640px) 100vw, 50vw"
              className="object-cover"
            />
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};
